/**
 * POR QUE A SALA NÃO FOI PREPARADA, em frase (03/11/2026, defeito da build 84 no iPhone). Antes, toda falha do pedido ao
 * portal que não trouxesse `error` virava "Confira a internet" — também a recusa por regra, a sessão vencida e o erro do
 * servidor. Aqui: com resposta, a frase do servidor (ou a do código HTTP); sem resposta, a de rede ou de tempo esgotado.
 * Quem usa: `prepararNoCelular` (celular), `aplicarNaSalaSemInternet` (computador) e o preparo automático.
 */
interface ErroDoPedido {
  response?: { status?: number; data?: { error?: string; codigo?: string } | string };
  code?: string;
  message?: string;
}

export function fraseDaFalhaDoPreparo(e: unknown): string {
  const err = (e ?? {}) as ErroDoPedido;
  const resp = err.response;
  if (resp) {
    const dados = typeof resp.data === 'object' && resp.data ? resp.data : {};
    const status = Number(resp.status) || 0;
    if (dados.error) return dados.error;
    if (status === 401) return 'Sua sessão no portal venceu. Entre de novo e prepare a sala.';
    if (status === 403) return 'Sua conta não pode preparar esta sala.';
    if (status === 404) return 'O portal não encontrou este simulado.';
    return `O portal recusou o pedido (código ${status || 'desconhecido'}). Tente de novo; se repetir, use "Relatar algo".`;
  }
  if (err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT') return 'O portal demorou demais para responder. Tente de novo.';
  if (err.code === 'ERR_NETWORK' || /network error/i.test(err.message ?? '')) return 'Sem conexão com o portal. Confira a internet e tente de novo.';
  // Erro que não é do pedido HTTP (o interceptador, a ponte): a frase dele.
  if (err.message) return err.message;
  return 'Não foi possível preparar a sala agora. Tente de novo.';
}
